export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/zonademand_UB_destkop.f446768e.png";